const TRAVEL_DATA = {
  globe_showing_europe_africa: '🌍',
  globe_showing_americas: '🌎',
  globe_showing_asia_australia: '🌏',
  globe_with_meridians: '🌐',
  world_map: '🗺',
  map_of_japan: '🗾',
  compass: '🧭',
  snow_capped_mountain: '🏔',
  mountain: '⛰',
  volcano: '🌋',
  mount_fuji: '🗻',
  camping: '🏕',
  beach_with_umbrella: '🏖',
  desert: '🏜',
  desert_island: '🏝',
  national_park: '🏞',
  stadium: '🏟',
  classical_building: '🏛',
  building_construction: '🏗',
  brick: '🧱',
  rock: '🪨',
  wood: '🪵',
  hut: '🛖',
  houses: '🏘',
  derelict_house: '🏚',
  house: '🏠',
  house_with_garden: '🏡',
  office_building: '🏢',
  japanese_post_office: '🏣',
  post_office: '🏤',
  hospital: '🏥',
  bank: '🏦',
  hotel: '🏨',
  love_hotel: '🏩',
  convenience_store: '🏪',
  school: '🏫',
  department_store: '🏬',
  factory: '🏭',
  japanese_castle: '🏯',
  castle: '🏰',
  wedding: '💒',
  tokyo_tower: '🗼',
  statue_of_liberty: '🗽',
  church: '⛪',
  mosque: '🕌',
  hindu_temple: '🛕',
  synagogue: '🕍',
  shinto_shrine: '⛩',
  kaaba: '🕋',
  fountain: '⛲',
  tent: '⛺',
  foggy: '🌁',
  night_with_stars: '🌃',
  cityscape: '🏙',
  sunrise_over_mountains: '🌄',
  sunrise: '🌅',
  cityscape_at_dusk: '🌆',
  sunset: '🌇',
  bridge_at_night: '🌉',
  hot_springs: '♨',
  carousel_horse: '🎠',
  playground_slide: '🛝',
  ferris_wheel: '🎡',
  roller_coaster: '🎢',
  barber_pole: '💈',
  circus_tent: '🎪',
  locomotive: '🚂',
  railway_car: '🚃',
  high_speed_train: '🚄',
  bullet_train: '🚅',
  train: '🚆',
  metro: '🚇',
  light_rail: '🚈',
  station: '🚉',
  tram: '🚊',
  monorail: '🚝',
  mountain_railway: '🚞',
  tram_car: '🚋',
  bus: '🚌',
  oncoming_bus: '🚍',
  trolleybus: '🚎',
  minibus: '🚐',
  ambulance: '🚑',
  fire_engine: '🚒',
  police_car: '🚓',
  oncoming_police_car: '🚔',
  taxi: '🚕',
  oncoming_taxi: '🚖',
  automobile: '🚗',
  oncoming_automobile: '🚘',
  sport_utility_vehicle: '🚙',
  pickup_truck: '🛻',
  delivery_truck: '🚚',
  articulated_lorry: '🚛',
  tractor: '🚜',
  racing_car: '🏎',
  motorcycle: '🏍',
  motor_scooter: '🛵',
  manual_wheelchair: '🦽',
  motorized_wheelchair: '🦼',
  auto_rickshaw: '🛺',
  bicycle: '🚲',
  kick_scooter: '🛴',
  skateboard: '🛹',
  roller_skate: '🛼',
  bus_stop: '🚏',
  motorway: '🛣',
  railway_track: '🛤',
  oil_drum: '🛢',
  fuel_pump: '⛽',
  wheel: '🛞',
  police_car_light: '🚨',
  horizontal_traffic_light: '🚥',
  vertical_traffic_light: '🚦',
  stop_sign: '🛑',
  construction: '🚧',
  anchor: '⚓',
  ring_buoy: '🛟',
  sailboat: '⛵',
  canoe: '🛶',
  speedboat: '🚤',
  passenger_ship: '🛳',
  ferry: '⛴',
  motor_boat: '🛥',
  ship: '🚢',
  airplane: '✈',
  small_airplane: '🛩',
  airplane_departure: '🛫',
  airplane_arrival: '🛬',
  parachute: '🪂',
  seat: '💺',
  helicopter: '🚁',
  suspension_railway: '🚟',
  mountain_cableway: '🚠',
  aerial_tramway: '🚡',
  satellite: '🛰',
  rocket: '🚀',
  flying_saucer: '🛸',
  bellhop_bell: '🛎',
  luggage: '🧳',
  hourglass_done: '⌛',
  hourglass_not_done: '⏳',
  watch: '⌚',
  alarm_clock: '⏰',
};

export default TRAVEL_DATA;
